import React from 'react';
import * as Sentry from '@sentry/browser';
import defaultSettings from '../defaultSettings';
const { sentryDsn } = defaultSettings;
import sentryConfig from '../config/sentry.config';
import { genRanHex } from '@/utils/utils';

if (defaultSettings.env === 'production' || defaultSettings.env === 'develop') {
  Sentry.init({
    beforeSend(breadcrumb: any, hint: any) {
      console.log(breadcrumb);
      return breadcrumb;
    },
    dsn: sentryDsn,
    release: sentryConfig.release,
  });
}

// 解决微信内置浏览器打开字体变大
// @ts-ignore
if (
  typeof WeixinJSBridge == 'object' &&
  typeof WeixinJSBridge.invoke == 'function'
) {
  handleFontSize();
} else {
  if (document.addEventListener) {
    document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
  } else {
    // @ts-ignore
    if (document.attachEvent) {
      // @ts-ignore
      document.attachEvent('WeixinJSBridgeReady', handleFontSize);
      // @ts-ignore
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
    }
  }
}
// @ts-ignore
function handleFontSize() {
  // 设置网页字体为默认大小
  // @ts-ignore
  WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  // 重写设置网页字体大小的事件
  // @ts-ignore
  WeixinJSBridge.on('menu:setfont', function () {
    // @ts-ignore
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  });
}

sessionStorage.setItem('deviceId', genRanHex(16));
